import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useRemoveFromBlacklisting } from "../../../hooks/visitor/mutation";

interface RemoveVisitorFromBlacklistingModalProps {
  blacklistedId: number;
  isOpen: boolean;
  onOpenChange: () => void;
}

const RemoveVisitorFromBlacklistingModal = ({
  blacklistedId,
  isOpen,
  onOpenChange,
}: RemoveVisitorFromBlacklistingModalProps) => {
  const { t } = useTranslation();

  const {
    mutateAsync: RemoveFromBlacklisting,
    isPending: isRemoveFromBlacklistingLoading,
  } = useRemoveFromBlacklisting();

  const handleRemoveFromBlacklisting = useCallback(async () => {
    try {
      const body = {
        encryptedId: blacklistedId,
      };
      await RemoveFromBlacklisting(body);
      toast.success(t("removedFromBlacklisting"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    } finally {
      onOpenChange();
    }
  }, [RemoveFromBlacklisting, blacklistedId, onOpenChange, t]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmRemoveVisitorFromBlacklisting")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleRemoveFromBlacklisting}
            isLoading={isRemoveFromBlacklistingLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("remove")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(RemoveVisitorFromBlacklistingModal);
